var _g, _path, _g2, _path2, _path3, _path4, _g3, _path5, _path6, _path7, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34414",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 11,
    width: 21,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7773 11H37.4543V29.2773H17.7773V11Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5615 29.1659C27.3997 29.1659 27.25 29.1012 27.1408 28.992C22.8971 24.7483 18.5078 20.359 18.5078 15.8848C18.5078 13.2229 20.6681 11.0586 23.33 11.0586C25.1868 11.0586 26.7524 11.8555 27.5655 13.0975C28.3625 11.7827 29.831 11.0586 31.7849 11.0586C34.4468 11.0586 36.6111 13.2229 36.6111 15.8848C36.6111 20.355 32.2299 24.7402 27.9903 28.9799L27.9782 28.992C27.8689 29.1012 27.7152 29.1659 27.5615 29.1659ZM23.33 12.248C21.3275 12.248 19.6972 13.8783 19.6972 15.8848C19.6972 19.728 23.6212 23.7896 27.5574 27.7298C31.4936 23.7896 35.4218 19.732 35.4218 15.8848C35.4218 13.8783 33.7915 12.248 31.7849 12.248C30.3367 12.248 28.5243 12.7132 28.144 14.9341C28.0955 15.2294 27.8325 15.4438 27.5332 15.4277C27.2379 15.4155 26.9911 15.1849 26.9668 14.8856C26.8171 13.1541 25.021 12.248 23.33 12.248Z",
    fill: "#06513D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6014 20.5735H25.467C25.0544 20.5735 24.7227 20.2418 24.7227 19.8292C24.7227 19.4206 25.0544 19.0889 25.467 19.0889H29.6014C30.01 19.0889 30.3418 19.4206 30.3418 19.8292C30.3418 20.2418 30.01 20.5735 29.6014 20.5735Z",
    fill: "#06513D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5334 22.6386C27.1208 22.6386 26.7891 22.3069 26.7891 21.8983V17.7598C26.7891 17.3513 27.1208 17.0195 27.5334 17.0195C27.942 17.0195 28.2737 17.3513 28.2737 17.7598V21.8983C28.2737 22.3069 27.942 22.6386 27.5334 22.6386Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13506_34414",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 15,
    width: 12,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.8115H23.9907V35.4885H12V15.8115Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13506_34414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3371 35.2792C19.1631 35.2792 18.9932 35.2063 18.8759 35.0648C18.6736 34.8139 18.4107 34.4984 18.1032 34.1343C17.1242 32.9692 15.7892 31.3713 14.7334 29.9594C14.4664 29.6034 13.7382 28.2522 13.1192 26.7433C12.3061 24.761 12.0027 23.3047 12.2131 22.4106L13.4307 17.2406C13.5521 16.7349 13.9486 16.4072 14.4461 16.4072C15.4494 16.4072 16.5215 17.7058 16.5781 19.8823C16.5781 19.9268 16.574 19.9713 16.566 20.0158L16.5498 20.0967C16.2261 21.6946 16.0643 22.4956 16.1776 23.1429C16.2059 23.3047 16.2545 23.4705 16.3232 23.6485C16.57 23.2804 16.9624 23.0701 17.4155 23.0701C18.1477 23.0701 18.9932 23.5879 19.9277 24.6033C20.3363 24.9997 20.842 25.5054 21.6592 26.4439C21.8533 26.6705 21.999 26.8283 22.1122 26.9577C22.533 27.4189 22.5936 27.5119 22.7029 28.1066C22.7312 28.2725 22.7716 28.5031 22.8485 28.8307L23.6738 32.5364C23.7304 32.7953 23.609 33.0623 23.3744 33.1877L19.6203 35.2104C19.5272 35.2589 19.4342 35.2792 19.3371 35.2792ZM14.5554 17.6451L13.3701 22.6817C13.0181 24.1704 15.2269 28.6366 15.6841 29.2474C16.7197 30.631 18.0466 32.2168 19.0134 33.3697C19.1833 33.576 19.3411 33.7621 19.4827 33.932L22.4156 32.3543L21.6875 29.0897C21.6066 28.7377 21.5621 28.495 21.5337 28.317C21.5095 28.1916 21.4852 28.0581 21.469 28.0297C21.4528 27.9933 21.3517 27.8841 21.2344 27.7547C21.1211 27.6333 20.9633 27.4593 20.7611 27.2247C19.9641 26.3064 19.4787 25.825 19.0863 25.4447C19.0782 25.4366 19.0701 25.4285 19.062 25.4204C18.0506 24.316 17.5126 24.2594 17.4155 24.2594C17.3427 24.2594 17.3265 24.2756 17.3063 24.316C17.193 24.5102 17.189 25.1049 17.6339 25.8816C17.6623 25.918 17.6946 25.9585 17.731 26.003L17.7998 26.0839C18.0021 26.3185 18.4188 26.808 19.2319 27.7911C19.2359 27.7992 19.24 27.8032 19.2481 27.8113C19.422 28.0419 19.4584 28.2725 19.3492 28.495C19.2481 28.6972 19.0418 28.8227 18.8152 28.8227C18.5361 28.8227 18.4147 28.6851 18.1841 28.41C18.0749 28.2806 17.9252 28.1026 17.7634 27.9084C17.4317 27.5119 17.0514 27.0508 16.8168 26.7635C16.7156 26.6422 16.6752 26.5896 16.6388 26.5329L16.5174 26.3428C14.7131 23.5231 14.6808 23.3451 15.3806 19.862L15.3847 19.8458C15.3361 18.4664 14.8224 17.8191 14.5554 17.6451Z",
    fill: "#06513D"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7152 38.5566C20.6586 38.5566 20.6019 38.5486 20.5453 38.5324C20.3916 38.4879 20.2662 38.3827 20.1933 38.2451L18.5145 35.1261C18.4417 34.9886 18.4255 34.8268 18.47 34.673C18.5145 34.5233 18.6197 34.3939 18.7572 34.3211L23.6522 31.6915C23.9394 31.5338 24.2995 31.643 24.4572 31.9302L26.132 35.0452C26.2089 35.1868 26.2251 35.3486 26.1806 35.4983C26.132 35.652 26.0309 35.7774 25.8934 35.8543L20.9984 38.4838C20.9094 38.5324 20.8123 38.5566 20.7152 38.5566ZM19.8454 35.0857L20.9579 37.1569L24.8051 35.0857L23.6926 33.0184L19.8454 35.0857Z",
    fill: "#06513D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8155 35.5516C35.7184 35.5516 35.6213 35.5314 35.5323 35.4829L31.7741 33.4601C31.5395 33.3347 31.4181 33.0677 31.4747 32.8088L32.304 29.1032C32.3809 28.7715 32.4214 28.5409 32.4497 28.375C32.5589 27.7804 32.6155 27.6873 33.0403 27.2261C33.1536 27.1007 33.2992 26.9429 33.4934 26.7164C34.3106 25.7779 34.8163 25.2722 35.2248 24.8757C36.1593 23.8603 37.0048 23.3425 37.733 23.3425C38.1901 23.3425 38.5825 23.5529 38.8253 23.917C38.8981 23.743 38.9466 23.5771 38.975 23.4153C39.0882 22.7681 38.9264 21.9671 38.6028 20.3691L38.5866 20.2882C38.5785 20.2437 38.5745 20.1992 38.5745 20.1547C38.6311 17.9783 39.6991 16.6797 40.7064 16.6797C41.1999 16.6797 41.6004 17.0033 41.7178 17.513L42.9354 22.6831C43.4452 24.8312 40.7994 29.7222 40.4192 30.2319C39.3633 31.6437 38.0243 33.2417 37.0493 34.4068C36.7419 34.7709 36.4789 35.0864 36.2726 35.3372C36.1553 35.4788 35.9894 35.5516 35.8155 35.5516ZM32.7329 32.6268L35.6658 34.2045C35.8074 34.0346 35.9652 33.8485 36.1351 33.6462C37.106 32.4892 38.4288 30.9075 39.4685 29.5199C39.9378 28.8888 42.1344 24.4591 41.7784 22.9542L40.5931 17.9176C40.3302 18.0915 39.8164 18.7388 39.7638 20.1183L39.7679 20.1345C40.4677 23.6176 40.4354 23.7956 38.6311 26.6112L38.5097 26.8054C38.4733 26.862 38.4288 26.9187 38.3277 27.036C38.0971 27.3192 37.729 27.7682 37.3851 28.1808C37.2233 28.3791 37.0776 28.553 36.9684 28.6825C36.7338 28.9576 36.6165 29.0951 36.3414 29.0951C36.3373 29.0951 36.3373 29.0951 36.3333 29.0951C36.1108 29.0951 35.9045 28.9697 35.8033 28.7674C35.6901 28.5449 35.7265 28.3143 35.9045 28.0838C35.9085 28.0757 35.9126 28.0716 35.9166 28.0635C36.6893 27.1331 37.0979 26.6517 37.3123 26.3928L37.4134 26.2795C37.4498 26.231 37.4822 26.1905 37.5146 26.15C37.9596 25.3774 37.9555 24.7827 37.8422 24.5885C37.822 24.5521 37.8058 24.5319 37.733 24.5319C37.6359 24.5319 37.0979 24.5885 36.0865 25.6929C36.0784 25.701 36.0703 25.7091 36.0622 25.7172C35.6698 26.0975 35.1844 26.5829 34.3915 27.4972C34.1852 27.7318 34.0314 27.9017 33.9141 28.0271C33.8049 28.1485 33.6997 28.2658 33.6795 28.3022C33.6633 28.3265 33.6431 28.46 33.6188 28.5854C33.5864 28.7634 33.5419 29.0061 33.4651 29.3621L32.7329 32.6268Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13506_34414",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 31,
    width: 10,
    height: 8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1328 31.3438H37.4535V38.933H28.1328V31.3438Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13506_34414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4354 38.8242C34.3383 38.8242 34.2412 38.7999 34.1522 38.7514L29.2572 36.1178C29.1197 36.045 29.0145 35.9196 28.97 35.7659C28.9255 35.6162 28.9417 35.4544 29.0145 35.3128L30.6933 32.1978C30.8471 31.9106 31.2071 31.8014 31.4984 31.9591L36.3893 34.5887C36.6806 34.7464 36.7858 35.1065 36.632 35.3937L34.9572 38.5087C34.8844 38.6462 34.755 38.7514 34.6053 38.7959C34.5486 38.8121 34.492 38.8242 34.4354 38.8242ZM30.3454 35.3532L34.1926 37.4245L35.3051 35.3532L31.4579 33.286L30.3454 35.3532Z",
    fill: "#06513D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34414",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34414",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcons);
export default __webpack_public_path__ + "static/media/TitleIcons.a0ce117cf69ee85f9b35435be4df5a17.svg";
export { ForwardRef as ReactComponent };